import React from 'react';

const ComputerIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={(size * 18) / 24}
    viewBox='0 0 24 18'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M22.2162 0L21.7192 2.2496H8.04236L8.53937 0H22.2162ZM12.4978 7.8744H14.777L15.274 5.6248H12.9948L12.4978 7.8744ZM21.5133 13.4992L23.2955 15.7504L22.7985 18H1.1437e-08L0.497018 15.7504L3.27485 13.4992L5.76154 2.2496H8.04075L6.05268 11.2496H19.7311L21.7192 2.2496H24L21.5133 13.4992ZM21.0147 15.7504L19.2325 13.4992H5.55405L2.77783 15.7504H21.0147Z' />
  </svg>
);

export default ComputerIcon;
